<template>
  <div class="column full-height">
    <div class="row justify-center">
      <p class="text-weight-medium full-width text-center q-mt-md">
        We found you! To help us link you to the correct company, please select
        the company you work for
      </p>
      <div class="full-width q-mt-xl">
        <SAISelect
          :disable="saving"
          :loading="loading"
          class="col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4"
          placeholder="Select Code"
          :value="selectedOrganisation"
          :options="userOrganisations"
          :error="error.$error"
          @input="$emit('update:organisation', $event)"
        />
      </div>
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg full-width">
      <SAIBtn
        :disable="loading || saving"
        :loading="saving"
        label="Next"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import { SAIBtn, SAISelect } from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfileEmploymentType',
  props: {
    loading: Boolean,
    saving: Boolean,
    error: {
      type: Object,
      default: () => ({})
    },
    selectedOrganisation: {
      type: Object,
      default: () => ({})
    },
    userOrganisations: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SAIBtn,
    SAISelect,
    QSpace
  }
};
</script>
